import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	currentGameProvider: null,
};

const gameProviderSlice = createSlice({
	name: "gameProvider",
	initialState,
	reducers: {
		setCurrentGameProvider(state, action) {
			state.currentGameProvider = action.payload;
		},
	},
});

export const { setCurrentGameProvider } = gameProviderSlice.actions;

export default gameProviderSlice.reducer;
